const grid = (): HTMLTableElement | null => document.querySelector<HTMLTableElement>("[data-cv-grid] table");

function sortedHeader(table: HTMLTableElement): HTMLTableCellElement | null {
  return table.querySelector<HTMLTableCellElement>("th[aria-sort=ascending], th[aria-sort=descending]");
}

function markStarLast(tbody: HTMLTableSectionElement, rows: HTMLTableRowElement[]): void {
  const starred = rows.filter((row) => row.classList.contains("starred")).length;
  const starredOnly = Boolean(document.querySelector<HTMLInputElement>("#cv-starred input")?.checked);
  rows.forEach((row, index) => {
    row.classList.toggle("star-last", !starredOnly && starred > 0 && starred < rows.length && index === starred - 1);
  });
  rows.forEach((row) => tbody.appendChild(row));
}

export function resortCampaigns(): void {
  const table = grid();
  const tbody = table?.tBodies[0];
  if (!table || !tbody) return;

  const th = sortedHeader(table);
  const key = th?.dataset.col || "client";
  const ascending = th?.getAttribute("aria-sort") !== "descending";
  const numeric = th?.dataset.sortType === "number";
  const value = (row: HTMLTableRowElement, col: string): string =>
    row.querySelector<HTMLElement>(`td[data-col="${col}"]`)?.dataset.sort || "";
  const rows = Array.from(tbody.querySelectorAll<HTMLTableRowElement>("tr.cv-row"));
  rows.sort((a, b) => {
    const pinned = Number(b.classList.contains("starred")) - Number(a.classList.contains("starred"));
    if (pinned) return pinned;
    const diff = numeric ? Number(value(a, key)) - Number(value(b, key)) : value(a, key).localeCompare(value(b, key), "sv");
    if (diff) return ascending ? diff : -diff;
    return value(a, "client").localeCompare(value(b, "client"), "sv") || value(a, "camp").localeCompare(value(b, "camp"), "sv");
  });
  markStarLast(tbody, rows);
}

function sortBy(th: HTMLTableCellElement): void {
  const table = th.closest("table");
  if (!table) return;

  const current = th.getAttribute("aria-sort");
  const ascending = current === "none" ? th.dataset.descFirst !== "true" : current !== "ascending";
  table.querySelectorAll<HTMLElement>("th[data-cv-sort]").forEach((other) => {
    other.setAttribute("aria-sort", "none");
    other.classList.remove("sorted");
  });
  th.setAttribute("aria-sort", ascending ? "ascending" : "descending");
  th.classList.add("sorted");
  resortCampaigns();
}

export function bindCsCampaignsView(): void {
  document.addEventListener("click", (e) => {
    const target = e.target as HTMLElement;
    if (!target.closest("[data-cv-grid]")) return;

    const th = target.closest<HTMLTableCellElement>("th[data-cv-sort]");
    if (th) return sortBy(th);

    if (target.closest("a, button, input, label")) return;
    const row = target.closest<HTMLElement>("tr.cv-row");
    if (row?.dataset.href) window.location.assign(row.dataset.href);
  });
}
